import { render, staticRenderFns } from "./ProgressFollowed.vue?vue&type=template&id=50937a32&scoped=true&"
import script from "./ProgressFollowed.vue?vue&type=script&lang=js&"
export * from "./ProgressFollowed.vue?vue&type=script&lang=js&"
import style0 from "./ProgressFollowed.vue?vue&type=style&index=0&id=50937a32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50937a32",
  null
  
)

export default component.exports